export const projects = [
  {
    title: "Auto Intro",
    image: "/Certs/AABW2026_Winner_Auto_Intro.png",
    description:
      "Winner of the 'Track Builder Experience' at Agentic AI Build Week 2026 (AABW) powered by GenAI Fund. Built as a solo developer (1 member), this tool automatically generates 45-60s intro videos for any repository by analyzing code structure, designing storyboards with Gemini, and rendering high-quality animations via Remotion. Scope: End-to-end full-stack development, AI model integration, and video generation automation.",
    skills: "TypeScript, Fastify, React, Remotion, Gemini API, Zod",
    github: "",
    preview:
      "https://aitalent.genaifund.ai/hackathon/project-gallery/8b5e5faa-48be-41d4-a50f-857f0bc0d185?returnTo=%2Fhackathon%2Fproject-gallery",
    type: "web",
  },
  // {
  //   title: "One Era",
  //   image: "/img/oneera.jpg",
  //   description:
  //     "A high-end model urban area real estate portal and web application in East HCMC. Developed full-stack features including the main user-facing frontend, backend API services, content management system (CMS), and interactive maps/listings. Scope: Frontend, Backend, CMS development, and database architecture.",
  //   skills: "Next.js, TailwindCSS, Node.js, PostgreSQL, CMS",
  //   github: "",
  //   preview: "https://oneera.com.vn/",
  //   type: "web",
  // },
  // {
  //   title: "Welltone Nha Trang 360",
  //   image: "/img/welltone.png",
  //   description:
  //     "Interactive real estate showcase with 360° views and 3D apartment visualization.",
  //   skills: "Next.js, TypeScript, TailwindCSS, Krpano",
  //   github: "",
  //   preview: "https://360.goku.agency/welltone-nha-trang",
  //   type: "web",
  // },
  // {
  //   title: "Listen Dictation",
  //   image:
  //     "/img/listendictation.png",
  //   description:
  //     "Practice English listening skills through dictation with AI transcriptions.",
  //   skills: "Next.js, FastAPI, TailwindCSS, TypeScript",
  //   github: "",
  //   preview: "https://listendictation.com/",
  //   type: "web",
  // },
  {
    title: "AVA Center",
    image: "/img/avacenter.png",
    description:
      "A real estate web platform for AVA Center project, providing property listings, information, and 360 virtual tour.",
    skills: "Next.js, TailwindCSS, Zustand, TypeScript",
    github: "",
    preview: "https://360.avacenter.vn/",
    type: "web",
  },
  {
    title: "Lapura",
    image: "/img/lapura.png",
    description:
      "A real estate web platform for Lapura project, providing property listings, information, and 360 virtual tour.",
    skills: "React.js, TailwindCSS, Redux, TypeScript",
    github: "",
    preview: "https://360vr.lapura.vn/",
    type: "web",
  },
  {
    title: "Việc làm T3D",
    image: "/img/vieclamt3d.png",
    description:
      "A job search platform connecting employers and job seekers with comprehensive listings and opportunities.",
    skills: "Next.js, TailwindCSS, TypeScript",
    github: "",
    preview: "https://www.vieclamt3d.com/",
    type: "web",
  },
  {
    title: "Shop BB",
    image: "/img/shopbb.png",
    description: "A web E-commerce built by the MERN stack.",
    skills: "ReactJS, NodeJS, ExpressJS, MongoDB, MUI",
    github: "https://github.com/lehuubao1810/shopBB",
    preview: "https://shop-bb.vercel.app/",
    type: "web",
  },
  {
    title: "E-Learning App",
    image: "/img/elearning.png",
    description:
      "An e-learning app with features for enhanced learning experiences",
    skills: "React Native, TypeScript, Redux, Tailwind",
    github: "https://github.com/lehuubao1810/quizMobile",
    preview:
      "https://www.canva.com/design/DAGJV3mKt24/VtBG8oe1gMUY7TC4Bw5IAA/view?utm_content=DAGJV3mKt24&utm_campaign=designshare&utm_medium=link&utm_source=editor",
    type: "web",
  },
  {
    title: "VocabTutor",
    image: "/img/client_vocab.png",
    description: "A web to learn vocab English, support AI to practice.",
    skills:
      "ReactJS, NextJS, MUI, GeminiAPI, NodeJS, ExpressJS, MongoDB, TypeScript, Redux, Firebase, Tailwind",
    github: "https://github.com/lehuubao1810/VocabTutorAI",
    preview: "https://vocabtutor.vercel.app/",
    type: "web",
  },
  {
    title: "UrFeeds",
    image: "/img/urfeeds.png",
    description: "A web to manage feeds and read posts.",
    skills: "ReactJS, TypeScript, Redux, Firebase, Tailwind",
    github: "https://github.com/lehuubao1810/UrFeeds",
    preview: "https://urfeeds.vercel.app/",
    type: "web",
  },
  {
    title: "Todo App",
    image:
      "https://raw.githubusercontent.com/lehuubao1810/Todo/dev/src/assets/1.png",
    description:
      "A web application that allows users to create, edit, delete, and mark tasks as completed.",
    skills: "ReactJS, Firebase",
    github: "https://github.com/lehuubao1810/todo_cdtt",
    preview: "https://todo-cdtt.vercel.app/",
    type: "web",
  },
  // {
  //   title: "MATH BIN",
  //   image: "https://lehuubao1810.github.io/dataquiz/mathbin.png",
  //   description:
  //     "A mobile application helps students improve their math skills by quizzes and exercises.",
  //   skills: "React Native, JSON Server",
  //   github: "https://github.com/lehuubao1810/QuizApp",
  //   preview:
  //     "https://drive.google.com/file/d/1w_o6jFag7hOHpiWwKWTvRd0DmqnqmmD4/view?usp=share_link",
  //   type: "mobile",
  // },
  {
    title: "Shift Cipher",
    image:
      "https://raw.githubusercontent.com/lehuubao1810/shiftCipher/main/src/assets/1.png",
    description:
      "An app help user encrypt and decrypt text with shift cipher (ASCII code).",
    skills: "ReactJS",
    github: "https://github.com/lehuubao1810/shiftCipher",
    preview: "https://shiftcipher.vercel.app/",
    type: "web",
  },
  // {
  //   title: "Calculator App",
  //   image:
  //     "https://raw.githubusercontent.com/lehuubao1810/Calculator-App/main/design/desktop-design-theme-1.jpg",
  //   description:
  //     "A calculator app can perform basic arithmetic operations (add, subtract, multiply, divide) and have three themes",
  //   skills: "HTML, CSS, JS",
  //   github: "https://github.com/lehuubao1810/Calculator-App",
  //   preview: "https://lehuubao1810.github.io/Calculator-App/",
  //   type: "web",
  // },
  // {
  //   title: "Rest Countries API",
  //   image:
  //     "https://raw.githubusercontent.com/lehuubao1810/countriesAPI/main/design/desktop-design-home-dark.jpg",
  //   description:
  //     "A web application that allows users to search for countries using the REST Countries API and filter them by region.",
  //   skills: "ReactJS",
  //   github: "https://github.com/lehuubao1810/countriesAPI",
  //   preview: "https://lhbcountriesapi.vercel.app/",
  //   type: "web",
  // },
];
